import '../styles/connect.scss';
import '@hotwired/turbo-rails';

import 'bundles/connect/bootstrap-overrides';
import 'bootstrap-5';

import 'components/page_header.scss';
import 'animate.css';
import 'trix';
import '@rails/actiontext';

import SharingConnect from 'bundles/sharing_connect';
import Search from 'bundles/connect/components/search';
import PasswordInput from 'bundles/connect/components/password_input';
import PhoneNumberInput from 'bundles/connect/components/phone_number_input';
import ProfileCompletion from 'bundles/connect/components/profile/completion';

import ReactOnRails from 'react-on-rails';

import 'packs/global';

import { Application } from '@hotwired/stimulus';
import ImageUploadPreviewController from 'bundles/connect/controllers/image_upload_preview_controller';
import autoFormController from 'bundles/connect/controllers/auto_form_controller';
import autoFocusController from 'bundles/connect/controllers/auto_focus_controller';
import BsTabDeeplink from 'bundles/connect/controllers/bs_tab_deeplink';
import Tooltip from 'bundles/connect/controllers/tooltip';
import Offcanvas from 'bundles/connect/controllers/offcanvas';
import VisibilityToggle from 'bundles/connect/controllers/visibility_toggle';
import ClickVisibilityToggle from 'bundles/connect/controllers/click_visibility_toggle';
import Lightbox from 'bundles/connect/controllers/lightbox';
import BootstrapNavActive from 'bundles/connect/controllers/bootstrap_nav_active';
import DisableWithController from 'bundles/connect/controllers/disable_with_controller';
import Popper from 'bundles/connect/controllers/popper';
import FormValidationController from '../bundles/connect/controllers/form_validation_controller';
import GoogleMapController from '../bundles/connect/controllers/google_map';
import InterestedResponseFormController from 'bundles/connect/controllers/forms/interested_response_form_controller';
import SignInCard from 'bundles/connect/components/sign_in_card';
import PropertyExclusiveListingOffcanvasContainer from 'bundles/connect/components/search/components/property_exclusive_listing_offcanvas_container';
import FormModalController from 'bundles/connect/controllers/form_modal_controller';
import TasksIndex from 'bundles/connect/components/tasks/tasks_index';
import ToastNotice from 'bundles/connect/controllers/toast_notice';
import ContactsIndex from 'bundles/connect/components/contacts';
import MyPropertiesIndex from 'bundles/connect/components/my_properties/my_properties_index';
import { handleBeforeFrameRender } from 'helpers/turbo_react';
import TagSettings from 'bundles/connect/components/tags/settings';
import NotificationSettings from 'bundles/connect/components/profile/notification_settings';
import CallListActionDropdown from '../bundles/connect/components/call_list/call_list_action_dropdown';
import ExportSettings from 'bundles/connect/components/profile/export_settings';
import ExportTemplateSettings from 'bundles/connect/components/profile/export_template_settings';
import ProfileSettings from 'bundles/connect/controllers/profile_settings';
import ImportListModal from 'bundles/connect/components/call_lists/import/import_list';
import CallConsole from 'bundles/connect/components/call_console/call_console';
import CallTemplates from 'bundles/connect/components/call_templates/call_templates';
import PropertyShowContainer from 'bundles/connect/components/off_market_properties/property_show_container';
import PropertyShowTurboContainer from 'bundles/connect/components/off_market_properties/property_show_turbo_container';
import RethinkAuthController from 'bundles/connect/controllers/rethink_auth_controller';
import EndTrial from 'bundles/connect/components/profile/end_trial';
import SavedSearches from 'bundles/connect/components/saved_searches/saved_searches';
import CallListDetails from 'bundles/connect/components/call_list/call_list_details';
import ProspectMemberStatus from 'bundles/connect/components/profile/prospect_member_status';
import CallListItems from 'bundles/connect/components/call_list/call_list_items';
import MailersTemplatesPreview from 'bundles/connect/components/mailers/preview/index';
import MailersTemplatesIndex from 'bundles/connect/components/mailers/templates/index';
import MailersTemplatesEdit from 'bundles/connect/components/mailers/templates/mailers_templates_edit';
import Avatars from 'bundles/connect/components/profile/avatars';

window.Stimulus = Application.start();
window.Stimulus.register('imageUploadPreview', ImageUploadPreviewController);
window.Stimulus.register('autoForm', autoFormController);
window.Stimulus.register('autoFocus', autoFocusController);
window.Stimulus.register('tooltip', Tooltip);
window.Stimulus.register('offcanvas', Offcanvas);
window.Stimulus.register('visibilityToggle', VisibilityToggle);
window.Stimulus.register('clickVisibilityToggle', ClickVisibilityToggle);
window.Stimulus.register('bsTabDeeplink', BsTabDeeplink);
window.Stimulus.register('formValidation', FormValidationController);
window.Stimulus.register('lightbox', Lightbox);
window.Stimulus.register('bootstrapNavActive', BootstrapNavActive);
window.Stimulus.register('disable', DisableWithController);
window.Stimulus.register('popper', Popper);
window.Stimulus.register('googleMap', GoogleMapController);
window.Stimulus.register('interestedResponseForm', InterestedResponseFormController);
window.Stimulus.register('formModal', FormModalController);
window.Stimulus.register('profileSettings', ProfileSettings);
window.Stimulus.register('toastNotice', ToastNotice);
window.Stimulus.register('rethinkAuth', RethinkAuthController);


ReactOnRails.setOptions({ turbo: true });

ReactOnRails.register({
  Search,
  SharingConnect,
  SignInCard,
  PasswordInput,
  PhoneNumberInput,
  ProfileCompletion,
  PropertyExclusiveListingOffcanvasContainer,
  TasksIndex,
  ContactsIndex,
  MyPropertiesIndex,
  TagSettings,
  NotificationSettings,
  CallListActionDropdown,
  ExportSettings,
  ExportTemplateSettings,
  ImportListModal,
  CallConsole,
  CallTemplates,
  PropertyShowContainer,
  PropertyShowTurboContainer,
  EndTrial,
  CallListDetails,
  ProspectMemberStatus,
  SavedSearches,
  CallListItems,
  MailersTemplatesPreview,
  MailersTemplatesIndex,
  MailersTemplatesEdit,
  Avatars
});

if (module.hot) {
  module.hot.accept('bundles/sharing_connect', () => ReactOnRails.reactOnRailsPageLoaded());
  module.hot.accept(
    'bundles/contact/requirements/requirements_form_container', () => ReactOnRails.reactOnRailsPageLoaded()
  );
  module.hot.accept('bundles/connect/components/search', () => ReactOnRails.reactOnRailsPageLoaded());
}

document.addEventListener('turbo:frame-render', (e) => {
  if (e.target.querySelector('.js-react-on-rails-component')) ReactOnRails.reactOnRailsPageLoaded();
});

document.addEventListener('turbo:before-frame-render', handleBeforeFrameRender);
